import React, { Component } from 'react';
import { Button } from '@blueprintjs/core';
import InputText from '../../../blueprintWrappers/InputText';
import IconSmallButton from '../../../blueprintWrappers/IconSmallButton';

class SubTaskNotEditable extends Component {



	render() {
		const p = this.props;

		return (
			<div className={"SubTaskEditable"} onKeyPress={this.handleKeyPress}>
				<input type="checkbox" onChange={() => p.toggleCheck(p.subtask)} defaultChecked={p.subtask.checked} /* BULLET &#9679; */ />
				{this.showTitle()}
				{this.showComment()}
			</div>
		);
	}

	showTitle = () => {
		const p = this.props;
		return (
			<div className={"EditableDetailShow"}>
				<h5>{p.subtask.title}
				<IconSmallButton
					iconName="minus"
					title={"remove subtask"}
					onClick={() => p.removeSubtask(p.subtask)}
				/>
				</h5>
			</div>
		)
	}

	showComment = () => {
		const p = this.props;
		return (
			<div className={"EditableDetailShow"}>
				<h5>
					{p.subtask.comment}
				</h5>
			</div>
		)
	}
}

export default SubTaskNotEditable;


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/TaskGroup/SubTaskNotEditable.js